import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { DropdownMenuTypePropType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';

import { useAvailableInsuranceOptions } from '../../services/insurance-service';
import { useFulfillmentPlannerContext } from '../context';

import { InsuranceOptionDropdown } from './index';

const InsuranceOptionContainerComponent = ({ id, dropdownMenuType, className, isPartOfInsurancePromoExperiment = false }) => {
  const { insuranceProvider, onInsuranceProviderChange, serviceIdAndSellerLabelProviderId } = useFulfillmentPlannerContext();
  const selectedInsuranceOptionName = insuranceProvider.name;
  const insuranceOptions = useAvailableInsuranceOptions(serviceIdAndSellerLabelProviderId?.sellerLabelProviderId);

  return (
    <InsuranceOptionDropdown
      className={className}
      dropdownMenuType={dropdownMenuType}
      id={id}
      insuranceOptions={insuranceOptions}
      isPartOfInsurancePromoExperiment={isPartOfInsurancePromoExperiment}
      onChange={onInsuranceProviderChange}
      selectedInsuranceOptionName={selectedInsuranceOptionName}
    />
  );
};

InsuranceOptionContainerComponent.propTypes = {
  id: PropTypes.string,
  dropdownMenuType: DropdownMenuTypePropType,
  className: PropTypes.string,
  isPartOfInsurancePromoExperiment: PropTypes.bool,
};

export const InsuranceOptionContainer = memo(InsuranceOptionContainerComponent);
